<template>
  <v-container class="ma-0 pa-0 grey lighten-4" fluid>
    <v-row justify="center" align="center" class="ancho">
      <v-divider
        :vertical="true"
        width="30"
        class="mr-2 mt-4 vertical-right"
      ></v-divider>
      <v-divider :vertical="true" width="50" :class="vertical"></v-divider>
      <v-divider
        :vertical="true"
        width="15"
        class="ml-2 mt-3 vertical-left"
      ></v-divider>
    </v-row>
  </v-container>
</template>

<script>
export default {
  props: {
    vertical: {
      type: String
    }
  }
};
</script>

<style scoped>
.v-divider--vertical {
  position: relative;
  height: 5em;
  border: solid 2px #00103b !important;
}
.vertical-right {
  position: relative;
  height: 3em;
  border: solid 2px #205f95 !important;
}
.vertical-left {
  position: relative;
  height: 1.5em;
  border: solid 2px #006a9e !important;
}
.ancho {
  width: 100%;
}
</style>
